<nf-table-properties
  class="accrued-interest-table-properties"
  [currentProperties]="currentProperties"
>
  <div class="table-properties-wrapper d-flex flex-wrap">
    <div class="format-toggle-control mr-4">
      <label class="small">
        Accrued Interest
        <nf-toggle
          [ngModel]="interestFormatToggle"
          (ngModelChange)="onInterestFormatChanged($event)"
          [states]="{ off: 'Decimal Amt', on: 'Dollar Amt' }"
        ></nf-toggle>
      </label>
    </div>
    <div class="date-range-control">
      <label class="small">
        Date Range
        <nf-daterange
          id="dateRange"
          class="mb-0"
          [ngModel]="_dateRange"
          (ngModelChange)="onDateRangeChanged($event)"
          [beginDateRequired]="false"
          [endDateRequired]="false"
        ></nf-daterange>
      </label>
    </div>
  </div>
</nf-table-properties>
